<template>
  <div>
    <input type="hidden" :name="'locations[' + location_index + '][location_status]'" v-model="location.location_status">
    <input type="hidden" :name="'locations[' + location_index + '][location_name]'" v-model="location.location_name">
    <input type="hidden" :name="'locations[' + location_index + '][zip]'"  v-model="location.zip">
    <input type="hidden" :name="'locations[' + location_index + '][pref]'"  v-model="location.pref">
    <input type="hidden" :name="'locations[' + location_index + '][address]'"  v-model="location.address">
    <input type="hidden" :name="'locations[' + location_index + '][tel]'"  v-model="location.tel">
    <input type="hidden" :name="'locations[' + location_index + '][fax]'"  v-model="location.fax">
    <input type="hidden" :name="'locations[' + location_index + '][business_hours]'"  v-model="location.business_hours">
    <input type="hidden" :name="'locations[' + location_index + '][access]'"  v-model="location.access">
    <input type="hidden" :name="'locations[' + location_index + '][map_type]'"  v-model="location.map_type">
    <input type="hidden" :name="'locations[' + location_index + '][google_map_url]'"  v-model="location.google_map_url">
    <input type="hidden" :name="'locations[' + location_index + '][google_map_embed]'"  v-model="location.google_map_embed">
  </div>
</template>
<script>
export default {
  props: ["location", "location_index"],
}
</script>
